import React from 'react';

const AboutUs = () => {
  return (
    <section className="package" id="package">
      <div className="container">

        <h2 className="h2 section-title">Why Choose Us?</h2>

        <p className="section-text">
        Welcome to our clinic, where your well-being is our priority. 
        Our dedicated team of healthcare professionals is committed to 
        providing comprehensive and compassionate medical services. 
        From routine check-ups to specialized treatments, we offer 
        a range of services designed to meet your healthcare needs. 
        </p>
        <div className='section_about'>
          <div className='text'>
            <h3>Compassionate Team</h3>
            <p>
            Nairobi Animal Wellness mobile veterinary clinic is staffed by a dedicated team of professionals 
            with a profound love for animals. We combine years of experience in veterinary medicine with a 
            commitment to providing affordable, convenient, and stress-free housecall care for your pets. 
            Whether it’s a routine checkup or addressing specific health concerns, 
            we bring high-quality veterinary services directly to your home, 
            ensuring the well-being of your furry family members.
            During our home visits, we pride ourselves on building trusting relationships with both pets 
            and their owners. By working closely with you, we create personalized health plans tailored 
            to your pet’s specific needs, ensuring their happiness and longevity. 
            Experience the convenience of expert care delivered right to your door—because 
            your pet’s health matters, and so do you.
            </p>
          </div>
          <div className='image1'>
            <img src="/Team.avif" alt="Image 2" className='vet_clinic'/>
          </div>
        </div>

        <div className='section_about'>
          <div className='image2'>
            <img src="/Advanced.avif" alt="Image 3" className='vet_clinic'/>
          </div>
          <div className='text'>
            <h3>Advanced Facilities</h3>
            <p>
            Our mobile clinic is outfitted with state-of-the-art technology and cutting-edge diagnostic tools, 
            allowing us to deliver the highest standard of veterinary care through housecalls. From advanced imaging equipment to modern surgical suites, 
            every aspect of our facility is designed to support accurate diagnoses and effective treatments. 
            We continually update our tools and techniques to stay at the forefront of veterinary medicine, 
            ensuring that your pets receive the same level of care you’d expect for any family member. 
            Our commitment to advanced facilities means we’re prepared to handle a wide range of medical needs with precision, efficiency, and compassion at your convenience.
            </p>
          </div>
        </div>

        <div className='section_about'>
          <div className='text'>
            <h3>Client Education</h3>
            <p>
            We believe that informed pet owners are essential to the well-being of our patients. 
            Our team is dedicated to empowering you with the knowledge you need to make the best decisions for your pet’s health. 
            From explaining medical conditions and treatment options to providing practical tips for daily at-home care, 
            we’re here to answer all your questions and support you every step of the way. We take the time to ensure you understand your pet’s unique needs, 
            helping you feel confident in managing their health between home visits. 
            </p>
          </div>
          <div className='image1'>
            <img src="/Education.jpg" alt="Image 2" className='vet_clinic'/>
          </div>
        </div>

        <div className='section_about'>
          <div className='image2'>
            <img src="/Community.avif" alt="Image 3" className='vet_clinic'/>
          </div>
          <div className='text'>
            <h3>Community Involvement</h3>
            <p>
            We’re proud to be more than just a mobile veterinary clinic; we’re an active, engaged member of the local community. 
            Through educational events, outreach programs, and partnerships with local shelters and pet organizations, 
            we are committed to promoting animal welfare and responsible pet ownership beyond our housecall visits. 
            Our team regularly participates in community events, offering pet care workshops, vaccination clinics, 
            and even volunteering services to support pets in need. Whether it’s through raising awareness or hands-on support, 
            we believe in giving back to the community that trusts us with their pets’ care. 
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
